<template>
  <div class="tela_cadastro">
    <div>
      <v-btn icon to="/atena/tela">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" dark class="mb-3">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card class="pa-3 mt-3">
      <form @submit.prevent="onSubmit">
        <Input type="text" label="Descrição" v-model="form.descricaotela" :v="$v.form.descricaotela" />
        <Input type="text" label="Tag Tela" v-model="form.tagtela" :v="$v.form.tagtela" />
        <Select label="Grupo de Tela" :options="optionsGrupo" v-model="form.identificadortelagrupo" :v="$v.form.identificadortelagrupo"/>
        <Select label="SubGrupo de Tela (1)" :options="optionsSubGrupo" v-model="form.identificadortelasubgrupo" :v="$v.form.identificadortelasubgrupo" @change=" form.identificadortelasubgrupo2 = ''" />
        <Select label="SubGrupo de Tela (2)" :options="optionsSubGrupo" v-model="form.identificadortelasubgrupo2" :v="$v.form.identificadortelasubgrupo2" :disabled="!form.identificadortelasubgrupo" />
        <Input type="text" label="Url" v-model="form.url" :v="$v.form.url" />

        <table class="table-siged mt-3">
          <thead>
            <tr>
              <th colspan="3">Funções da Tela</th>
            </tr>
            <tr>
              <th>Descrição</th>
              <th>Tag Função</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(funcao, index) in form.tela_funcoes" :key="funcao.identificadorfuncaotela">
              <td class="centro" style="width: 55%">
                 <InputTable
                  type="text"
                  class="input-tela"
                  maxlength="60"
                  v-model="funcao.descricaofuncao"
                  @blur="$v.form.tela_funcoes.$each[index].descricaofuncao.$touch()"
                  :msgsError="msgValidacao($v.form.tela_funcoes.$each[index].descricaofuncao)"/>
              </td>
              <td class="centro" style="width: 30%">
                <InputTable
                  type="text"
                  class="input-tela"
                  maxlength="20"
                  v-model="funcao.tagfuncaotela"
                  @blur="$v.form.tela_funcoes.$each[index].tagfuncaotela.$touch()"
                  :msgsError="msgValidacao($v.form.tela_funcoes.$each[index].tagfuncaotela)"/>
              </td>
              <td class="centro" style="width: 8%">
                <v-btn :disabled="!isLastIndex(index)" icon title="Adicionar" class="aulas-btn-acao" @click="adicionar">
                  <v-icon color="green">add</v-icon>
                </v-btn>
                <v-btn :disabled="form.tela_funcoes.length <= 1" icon title="Remover" class="aulas-btn-acao" @click="event => remover(index)">
                  <v-icon color="red">close</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="mt-3" style="text-align: right">
          <v-btn type="submit" :loading="loading" small dark color="teal" class="rounded-sm font-weight-regular" width="90px">Salvar</v-btn>
        </div>
      </form>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, maxLength, integer } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import InputTable from '@/components/InputTable';

const AtenaTelaRepository = RepositoryFactory.get('atenaTela');
const AtenaTelaGrupoRepository = RepositoryFactory.get('atenaTelaGrupo');

const setFormInicial = (props) => ({
  descricaotela: '',
  tagtela: '',
  identificadortelagrupo: '',
  identificadortelasubgrupo: '',
  identificadortelasubgrupo2: '',
  url: '',
  tela_funcoes: [{
    descricaofuncao: '',
    tagfuncaotela: '',
  }],
});

export default {
  name: 'TelaCadastro',
  components: {
    InputTable,
  },
  props: {
    id: [Number, String],
  },
  data() {
    return {
      form: setFormInicial(),
      loading: false,
      msgArrayError: [],
      submitText: '',
      snackbar: false,
      optionsGrupo: [],
      optionsSubGrupo: [],
    };
  },
  validations: {
    form: {
      descricaotela: { required, maxLength: maxLength(60) },
      tagtela: { required, maxLength: maxLength(20) },
      identificadortelagrupo: { integer, required },
      identificadortelasubgrupo: { integer },
      url: { required, maxLength: maxLength(60) },
      tela_funcoes: {
        required,
        $each: {
          descricaofuncao: { required, maxLength: maxLength(60) },
          tagfuncaotela: { required, maxLength: maxLength(20) },
        },
      },
    },
  },
  async beforeRouteEnter(to, from, next) {
    try{
      const { data } = await AtenaTelaGrupoRepository.getSelectTelaGrupo();

      let editar = {};
      if(to.params.id) {
        editar = await AtenaTelaRepository.getTela(to.params.id);
      }

      next(vm => {
        vm.montarGrupos(data.results.telaGrupo);
        vm.montarSubGrupos(data.results.telaSubGrupo);
        if(to.params.id) { vm.load(editar.data.results); }
      });
    }
    catch(e){
      next('/atena/tela');
    }
  },
  created(){
    this.$Progress.finish();
  },
  methods: {
    montarGrupos(grupos) {
      this.optionsGrupo = grupos.map((key) => ({ value: key.identificadortelagrupo, text: key.descricaotelagrupo }));
      this.optionsGrupo.unshift({ value: null, text: '' });
    },
    montarSubGrupos(subGrupos) {
      this.optionsSubGrupo = subGrupos.map((key) => ({ value: key.identificadortelasubgrupo, text: key.descricaotelasubgrupo }));
      this.optionsSubGrupo.unshift({ value: null, text: '' });
    },
    remover(index) {
      this.form.tela_funcoes.splice(index, 1);
    },
    adicionar() {
      this.form.tela_funcoes.push({
        descricaofuncao: '',
        tagfuncaotela: '',
      });
    },
    isLastIndex(index) {
      return index + 1 === this.form.tela_funcoes.length;
    },
    msgValidacao(v) {
      if(!v.required && v.$dirty) { return ['Campo obrigatório']; }
      if(typeof v.$params.maxLength !== 'undefined' && !v.maxLength && v.$dirty) { return [`O tamanho máximo é de ${v.$params.maxLength.max} caracteres`]; }
    },
    load(data) {
      this.form = { ...data };

      if(this.form.tela_funcoes.length <= 0) {
        this.form.tela_funcoes = [{ descricaofuncao: '', tagfuncaotela: '' }];
      }

      this.$Progress.finish();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        this.loading = true;
        this.msgArrayError = [];
        const funcao = (this.id)? 'put' : 'post';
        const { data } = await AtenaTelaRepository[`${funcao}Tela`](this.form);

        this.submitText = data.message;
        this.snackbar = true;

        setTimeout(() => {
          this.$root.$router.push({
            path: '/atena/tela',
          });
        }, 1000);
      } catch(error) {
        if (error.response && error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="scss">
.tela_cadastro {
  .input-tela {
    width: 90%;
    input {
      text-align: left;
      padding: 0px 13px;
    }
  }

  .aulas-btn-acao {
    margin: 0px;
    color: #4e4e4e!important;
  }
}
</style>
